<template>
  <div>
    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>

    <div class="columns is-multiline">
      <div class="column is-half">
        <div class="box">
          <admin-box-item title="기본 정보">
            <div class="columns is-multiline">
              <div class="column is-full" v-if="isInternalPlugin('user_grade') && $route.query.id">
                <admin-form-item label="회원 등급">
                  <lp-adm-drop-input ref="adminput_grade"
                                     :data.sync="userGradeList"
                                     :selectVal="selectedGrade"
                                     @onSelect="res => basicInfo.grade = res.value"
                                     placeholder="회원 등급"
                                     width="160px"
                                     listAlign="center"></lp-adm-drop-input>
                </admin-form-item>
              </div>
              <!--<div class="column is-full">
                <admin-form-item label="이미지" tip="회원 프로필 이미지로, 500x500의 이미지로 등록하는 것을 권장합니다.">
                  <input-img :url.sync="basicInfo.profile"></input-img>
                </admin-form-item>
              </div>-->
              <div class="column is-half">
                <admin-form-item label="성">
                  <input class="input"
                         :value="basicInfo.last_name"
                         @input="e => basicInfo.last_name = e.target.value"
                         placeholder="성"
                         type="text">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="이름">
                  <input class="input"
                         :value="basicInfo.name"
                         @input="e => basicInfo.name = e.target.value"
                         placeholder="이름"
                         type="text">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="아이디(이메일)*">
                  <input class="input"
                          :value="basicInfo.username"
                          @input="inputUserName"
                          placeholder="launchpack@launchpack.co.kr"
                          type="text" :disabled="inputDisabled" maxlength="30">
                  <!--<span v-if="!emailValid && basicInfo.username.length>0"></span>-->
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="회원번호">
                  <input class="input"
                         :value="basicInfo.user_num"
                         type="text" disabled>
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="비밀번호*">
                  <input class="input"
                        :value="basicInfo.password"
                        @input="e => basicInfo.password = e.target.value"
                         placeholder="비밀번호를 입력하세요."
                         type="password" maxlength="15">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="비밀번호 확인*">
                  <input class="input"
                        :value="basicInfo.passwordCheck"
                        @input="e => basicInfo.passwordCheck = e.target.value"
                        placeholder="비밀번호를 확인하는 곳 입니다."
                        type="password" maxlength="15">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="휴대전화번호">
                  <input class="input"
                        :value="basicInfo.phone"
                        @input="e => basicInfo.phone = e.target.value"
                         placeholder="010-1234-5678"
                        type="text" maxlength="13">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="배대지">
                  <lp-adm-drop-input :data="countries"
                                     :selectVal="countries.find(i => i.value === basicInfo.country).label"
                                     @onSelect="res => basicInfo.country = res.value"
                                     placeholder="배대지"
                                     width="160px"
                                     listAlign="center"></lp-adm-drop-input>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="주소">
                  <lp-address :data.sync="basicInfo.address"></lp-address>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
        <div class="box" v-if="$route.query.id">
          <user-order-list></user-order-list>
        </div>
      </div>

      <div class="column is-half" v-if="$route.query.id && !isLaunchpack">
        <!-- 적립금 관리 -->
        <user-point-manage v-if="isInternalPlugin('point_coupon')"></user-point-manage>
        <div class="box" style="margin-top:20px">
          <admin-box-item v-if="false" title="서비스 사용정보">
            <div class="columns is-multiline">
              <div class="column is-6" v-if="performance.like || performance.like===0">
                <div class="flex space-between">
                  <div>상품 찜</div>
                  <div>{{ performance.like }}건</div>
                </div>
              </div>
              <div class="column is-6" v-if="performance.inquiry || performance.inquiry===0">
                <div class="flex space-between">
                  <div>상품 문의</div>
                  <div>{{ performance.inquiry }}건</div>
                </div>
              </div>
              <div class="column is-6" v-if="performance.review || performance.review===0">
                <div class="flex space-between">
                  <div>상품 후기</div>
                  <div>{{ performance.review }}건</div>
                </div>
              </div>
              <div class="column is-6" v-if="performance.product_call || performance.product_call===0">
                <div class="flex space-between">
                  <div>전화 주문</div>
                  <div>{{ performance.product_call }}건</div>
                </div>
              </div>
              <div class="column is-6" v-if="performance.request || performance.request===0">
                <div class="flex space-between">
                  <div>견적 요청</div>
                  <div>{{ performance.request }}건</div>
                </div>
              </div>
              <div class="column is-6" v-if="performance.bid || performance.bid===0">
                <div class="flex space-between">
                  <div>받은 견적서</div>
                  <div>{{ performance.bid }}건</div>
                </div>
              </div>
              <div class="column is-6" v-if="performance.order_request || performance.order_request===0">
                <div class="flex space-between">
                  <div>주문 요청</div>
                  <div>{{ performance.order_request }}건</div>
                </div>
              </div>
              <div class="column is-6" v-if="performance.order_success || performance.order_success===0">
                <div class="flex space-between">
                  <div>주문 완료</div>
                  <div>{{ performance.order_success }}건</div>
                </div>
              </div>
              <!-- <admin-form-item> -->
              <!--<div class="service-usage-info"
                  v-for="(item, idx) in serviceInfo"
                  :key="'service-info'+idx">
                <span class="label service-usage-info-label">
                  {{ item.label }}</span>
                <div class="flex">
                  <span class="label">{{ item.count }}</span>
                  <span class="label">건</span>
                </div>
              </div>-->
              <!-- </admin-form-item>                 -->
            </div>
          </admin-box-item>
          <admin-box-item title="고객 히스토리 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="관리자용 로그 및 메모" tip="관리자만 확인할 수 있는 메모를 별도로 입력할 수 있으며, 고객 특이사항 등을 입력할 수 있습니다.">
                  <admin-log-memo :memoLogsValue.sync="memo_logs"
                                  :newMemoValue.sync="newMemo"
                                  placeholder="고객 관련 간단메모를 입력하는 곳 입니다."
                                  @onClickHistoryBtn="res => clickHistoryBtn(res)">
                  </admin-log-memo>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <!--<div class="column is-half" v-if="false">
        <div class="box">
          <admin-box-item title="부가 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="생년월일">
                  <div class="columns is-multiline">
                    <div class="column">
                      <lp-adm-drop-input @onSelect="selYear" :selectVal="basicInfo.birth.year" :data.sync="yearArr"
                                        placeholder="연" listAlign="center" :number_length="4"
                                        ></lp-adm-drop-input>
                    </div>
                    <div class="column">
                      <lp-adm-drop-input @onSelect="selMonth" :selectVal="basicInfo.birth.month" :data.sync="monthArr"
                                        placeholder="월" listAlign="center" :number_length="2"
                                        ></lp-adm-drop-input>
                    </div>
                    <div class="column">
                      <lp-adm-drop-input @onSelect="selDate" :selectVal="basicInfo.birth.date" :data.sync="dateArr"
                                        placeholder="일" listAlign="center" :number_length="2"
                                        ></lp-adm-drop-input>
                    </div>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="성별">
                  <lp-radio :val.sync="basicInfo.gender"
                            value_name="value"
                            label_name="label"
                            :data="gender"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :label="isLaunchpack ? '가입경로' : '가입경로/연동 SNS 계정 정보'" tip="회원이 SNS 계정을 이용하여 회원가입하는 경우 수집되는 데이터이며, 관리자가 회원 등록할 때에는 입력하실 수 없습니다.">
                  <input class="input"
                         :value="basicInfo.channel"
                         @input="e => basicInfo.login_type = e.target.value"
                         type="text"
                         maxlength="20"
                         :disabled="true">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="마케팅 수신 동의">
                  <lp-check-bool :checkedVal.sync="basicInfo.email_agreement" label="이메일 수신동의" style="margin-bottom:4px"></lp-check-bool>
                  <lp-check-bool :checkedVal.sync="basicInfo.push_agreement" label="앱푸시 수신동의" style="margin-bottom:4px"></lp-check-bool>
                  <lp-check-bool :checkedVal.sync="basicInfo.sms_agreement" label="sms 수신동의"></lp-check-bool>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>-->

      <!--<div class="column is-half" v-if="user_param && user_param.length>0">
        &lt;!&ndash; 맞춤 DB &ndash;&gt;
        <div class="box">
          <admin-box-item title="맞춤 DB" subtitle="기본으로 제공하는 데이터 수집 항목 외에 추가 정보를 자유롭게 구성하여 수집/입력할 수 있도록 제공하는 기능입니다.">
            <div class="columns is-multiline">
              <div class="column is-full"
                   v-for="(param, index) in user_param"
                   v-bind:key="'param_input'+index">
                <admin-form-item :label="param.name">
                  <input-param :param.sync="param"></input-param>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>-->
    </div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>


  </div>
</template>

<script>
  import moment from 'moment';
  import LpInputText from '../../module/common/LpInputText'
  import LpRadio from '../../module/common/LpRadio'
  import InputImg from '../../module/common/InputImg'
  import LpAddress from '../../module/common/LpAddress'
  import LpAdmDropInput from '../../module/common/LpAdmDropInput'
  import LpDateDropInput from "../../module/common/LpDateDropInput";
  import LpSortDropDown from "../../module/common/LpSortDropDown";
  import AdminLogMemo from '../../module/common/AdminLogMemo'
  import InputParam from "../../module/custom/InputParam";
  import CreateMixin from "@/mixins/CreateMixin"
  import UserPointManage from "./components/UserPointManage";
  import LpCheckBool from "../../module/common/LpCheckBool";
  import UserOrderList from "./components/UserOrderList";

  export default {
    name: 'UserReg',
    layout: 'Main',
    components: {
      UserOrderList,
      LpCheckBool,
      UserPointManage,
      InputParam,
      LpSortDropDown,
      LpDateDropInput,
      LpInputText,
      LpRadio, InputImg, LpAddress,
      LpAdmDropInput,
      AdminLogMemo
    },
    mixins: [
      CreateMixin
    ],
    data() {
      return {
        countries: [{value: 'de', label: '독일'}, {value: 'fr', label: '프랑스'}],
        // 맞춤 DB
        param_list:[],
        user_param: [],
        testModal: false,
        customDB: [],
        // 연락처
        phone: [
          {label: ''}
        ],
        // 기본 정보
        basicInfo: {
          country: 'de',
          birth: {
            year: '',
            month: '',
            date: '',
          },
          gender: '',
          profile: '',
          username: '',
          // id: '',
          password: '',
          passwordCheck: '',
          email: '',
          address: {
            full: '',
            sido: '',
            sigungu: '',
            dong: '',
            zipcode: '',
            detail: ''
          },
          name: '',
          nickname: '',
          joined_type: '',
          phone: ''
        },
        // 맞춤 DB필드 정보
        customizedInfo: {},
        performance: {},
        // 서비스 사용 정보
        /*serviceInfo: [
          {label: '상품 찜', count: 0},
          {label: '견적요청', count: 0},
          {label: '받은 견적서', count: 0},
          {label: '주문신청', count: 0},
          {label: '주문완료', count: 0},
          {label: '상품후기', count: 0},
          {label: '상품문의', count: 0}
        ],*/
        // 고객 히스토리 정보
        newMemo: '',
        memo_logs: [],
        // 성별 라디오 용
        gender: [
          {label: '여자', value: 'female'},
          {label: '남자', value: 'male'},
        ],
        // 생년월일 Array
        yearArr: [],
        monthArr: [],
        dateArr: [],
        emailValid: false,
        userGradeList: [],
      }
    },
    computed: {
      inputDisabled() {
        if (this.$route.query.id) {
          return true;
        }
      },
      selectedGrade() {
        let grade = find(this.userGradeList, 'value', this.basicInfo.grade);
        if(grade)
          return grade.label;
        else
          return '';
      },
      userName() {
        let user = find(this.emailArr, 'value', this.basicInfo.username2);
        if (user !== undefined)
          return user.label;
        else
          return '';
      }
    },
    watch: {
      'basicInfo.username'(n) {
        this.emailValid = this.validateEmail(n);
      },
      'basicInfo.phone'(n) {
        if(n) this.basicInfo.phone = autoHyphenPhone(this.basicInfo.phone)
      },
      'basicInfo.birth.year'(n) {
        this.monthArr = [];
        this.dateArr = [];

        let month = 1;
        for (let i = 0; i < 12; i++) {
          let monthObj = {
            label: month.toString(),
            value: month.toString()
          };
          this.monthArr.push(monthObj);
          month++;
        }

        let day = (this.basicInfo.birth.year).toString() + '-' + (this.basicInfo.birth.month).toString();
        day = moment(day).endOf('month').format('DD');

        for (let i = 1; i <= day; i++) {
          this.dateArr.push({
            label: i.toString(),
            value: i.toString()
          });
        }
      },
      'basicInfo.birth.month'(n) {
        this.dateArr = [];
        let day = (this.basicInfo.birth.year).toString() + '-' + (this.basicInfo.birth.month).toString();
        day = moment(day).endOf('month').format('DD');

        for (let i = 1; i <= day; i++) {
          this.dateArr.push({
            label: i.toString(),
            value: i.toString()
          });
        }
      },
    },
    created() {
      // 연/월/일 Array 생성
      let century = parseInt(moment().format('YYYY')) - 100;
      for (let year = parseInt(moment().format('YYYY')); year >= century; year--) {
        this.yearArr.push({
          label: year.toString(),
          value: year.toString()
        });
      }

      for (let month = 1; month <= 12; month++) {
        this.monthArr.push({
          label: month.toString(),
          value: month.toString()
        });
      }

      this.getData();
      if(!this.isLaunchpack){
        this.getUserGrade();
      }

      let day = (this.basicInfo.birth.year).toString() + '-' + (this.basicInfo.birth.month).toString();
      day = moment(day).endOf('month').format('DD');

      for (let i = 1; i <= day; i++) {
        this.dateArr.push({
          label: i.toString(),
          value: i.toString()
        });
      }

    },
    methods: {
      // 유저 등급 가져오기
      getUserGrade() {
        this.$axios.get('admin/member/grade').then(res => {
          if (res.status === 200) {
            let list = [];
            res.data.forEach( item => {
              list.push({
                label: item.name,
                value: item.id
              });
            });
            this.userGradeList = list;
          }
        });
      },
      convertLoginType(name) {
        const types = {
          email: '이메일',
          kakao: '카카오',
          naver: '네이버',
          facebook: '페이스북',
          google: '구글',
          apple: '애플'
        };
        return types[name];
      },
      inputUserName (e){
        this.basicInfo.username = e.target.value;
        this.basicInfo.email = e.target.value;
      },
      paramAllList(){
        // 파라미터 리스트
        this.$axios.get('admin/member/user/param').then(res=>{
          if(res.status===200){
            this.param_list = res.data;
            let result = this.paramChecker(this.param_list, this.user_param);
            if(result.length > 0) this.user_param = this.user_param.concat(result);
            this.user_param.sort((a,b) => {
              return a.id > b.id ? 1 : a.id < b.id ? -1 : 0;
            });
          }
        })
      },
      validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      // 연 선택
      selYear(item) {
        if (item === undefined) return;
        this.basicInfo.birth.year = item.label;
      },
      // 월 선택
      selMonth(item) {
        if (item === undefined) return;
        this.basicInfo.birth.month = item.label;
      },
      // 일 선택
      selDate(item) {
        if (item === undefined) return;
        this.basicInfo.birth.date = item.label;
      },
      clickHistoryBtn(memo) {
        if (memo.trim()==='') return;

        this.$axios.post(this.getUrl('member/user/' + this.$route.query.id + '/memo'), {
          content: memo
        }).then(res => {
          if (res.status === 200) {
            let now = moment().format('YYYY-MM-DD HH:mm');
            let authorName = '';
            if (this.$store.getters.mode === 'admin') {
              authorName = this.$store.state.auth.admin.username;
            }
            else {
              authorName = this.$store.state.auth.partner.username;
            }
            this.memo_logs.splice(0,0,{
              created_time: now,
              author: authorName,
              content: memo
            });

            this.newMemo = '';
            //this.getData();
            this.toast('로그가 저장되었습니다.');
          }
        })
      },
      getData() {
        // 유저 정보가 있는 경우 가져오기
        if (this.$route.query.id) {
          this.$axios.get(this.getUrl('member/user/' + this.$route.query.id))
            .then(res => {
              if (res.status === 200) {
                this.basicInfo = res.data.user;
                this.user_param = res.data.params;
                this.performance = res.data.performance;

                let channel = '';
                let username = res.data.user.username;
                if(username.indexOf('@')>-1) {
                  channel = '이메일';
                } else if(username.indexOf('$')>-1) {
                  channel = this.convertLoginType(username.split('$')[0]);
                }
                let sns = [];
                for(let key of ['kakao','facebook','naver','apple','google']) {
                  if(this.basicInfo[`${key}_id`] && this.basicInfo[`${key}_id`] !== '') {
                    sns.push(this.convertLoginType(key));
                  }
                }
                if(sns.length>0) {
                  channel += ' / ' + sns;
                }

                this.basicInfo.channel = channel;

                let birth = res.data.user.birth;
                if (birth) {
                  this.basicInfo.birth = {
                    year: moment(birth).year(),
                    month: moment(birth).month() + 1,
                    date: moment(birth).date()
                  }
                }
                else {
                  this.basicInfo.birth = {
                    year: '',
                    month: '',
                    date: ''
                  }
                }
                let address = res.data.user.address;
                if (!address) {
                  this.basicInfo.address = {
                    sido: '',
                    sigungu: '',
                    dong: '',
                    detail: '',
                    post_code: '',
                    old: '',
                    new: ''
                  }
                }
                this.memo_logs = res.data.memo_logs;
                this.paramAllList();
              }
            });
        }
        else this.paramAllList();
      },
      saveData() {
        let errMsg = '';
        if (!this.basicInfo.username) errMsg = '아이디를';
        //else if(!this.basicInfo.name) errMsg = '이름을';
        else if (this.basicInfo.phone && this.basicInfo.phone.split('-').length < 3) errMsg = '휴대전화번호를 알맞게';
        //else if (!this.basicInfo.birth.year || !this.basicInfo.birth.month || !this.basicInfo.birth.date) errMsg = '생년월일을 알맞게'
        else if (this.login_type==='email' && !this.emailValid) errMsg = '이메일 타입에 맞게';
        //else if(this.basicInfo.nickname === '') errMsg = '닉네임을';
        if (!this.$route.query.id) {
          if (!this.basicInfo.password) errMsg = '비밀번호를';
          else if (!this.basicInfo.passwordCheck) errMsg = '비밀번호 확인을';
        }

        if (errMsg) {
          this.toast(errMsg + ' 입력해주세요.');
          return;
        }
        if (this.basicInfo.password !== this.basicInfo.passwordCheck) {
          this.toast('비밀번호를 확인해주세요.');
          return;
        }
        if (this.isLaunchpack && /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(this.basicInfo.password)) {
          this.toast('영문으로 비밀번호를 입력하세요.');
          return;
        }


        // 생년월일 데이터 맞춰서 보내기
        let basicInfo = this.cloneItem(this.basicInfo);
        let year = basicInfo.birth.year;
        let month = basicInfo.birth.month;
        let date = basicInfo.birth.date;
        let errBirth = false;
        if (!year && !month && !date) {
          basicInfo.birth = '';
        }
        else if (year && !month && !date) errBirth = true;
        else if (year && month && !date) errBirth = true;
        else if (!year && month && date) errBirth = true;
        else if (!year && !month && date) errBirth = true;
        else if (!year && month && !date) errBirth = true;
        else {
          basicInfo.birth = `${basicInfo.birth.year}-${basicInfo.birth.month}-${basicInfo.birth.date}`
        }

        if(errBirth===true) {
          this.toast('생년월일을 모두 선택해주세요.');
          return;
        }

        // 전화번호 (-)하이폰 없애서 보내기
        if(basicInfo.phone){
          basicInfo.phone = basicInfo.phone.replace(/-/gi,'');
        }

        this.$store.commit('setLoading', true);
        if (this.$route.query.id) {
          // user_param 추가
          basicInfo.params = this.user_param;
          this.$axios.patch(this.getUrl('member/user/' + this.$route.query.id), basicInfo).then(res => {
            if (res.status === 200) {
              this.$store.commit('setLoading', false);
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('user'));
            }
          }).catch(error => {
            if (error.response) {
              this.$store.commit('setLoading', false);
              this.toast(error.response.data.message);
            }
          });
        }
        else {
          basicInfo.params = this.user_param;
          this.$axios.post(this.getUrl('member/user'), basicInfo).then(res => {
            if (res.status === 200) {
              this.$store.commit('setLoading', false);
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('user'));
            }
          }).catch(error => {
            if (error.response) {
              this.$store.commit('setLoading', false);
              this.toast(error.response.data.message);
            }
          })
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

  .service-usage-info
    display flex
    justify-content space-evenly
    max-width 50%
    min-width 50%
    padding 4px 8px

  .service-usage-info-label
    display inline-block
    width 112px
    min-width 80px
    margin 0

  .user-reg-history-memo
    width 100%
    height 196px
    font-size .9rem
    display flex
    flex-wrap wrap
    border 1px solid #ddd
    border-radius 3px
    padding 12px
    overflow-y auto

  .history-memo-item
    width 100%
    margin-bottom 12px

  .user-reg-history-btn
    background-color $primary
    color #fff
    display inline-block
    padding 8px 12px
    margin-left 8px
    border-radius 3px
    cursor pointer


</style>
